import { gatewaySectorWorkFlows } from "../../../../../../../../../gateways/gatewaySectorWorkFlows";

export interface ObjectItem {
  uid: string;
  name: string;
  description: string;
  cost: {
    by: string;
    value: number;
    currency: string;
  };
  durationInMinutes: number;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedResponse<T> {
  page: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  items: T[];
}

export const fetchObjects = async (
  page: number,
  pageSize = 10,
  token?: string,
  name?: string
): Promise<PaginatedResponse<ObjectItem>> => {

  const queryParams = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });

  if (name) queryParams.append("name", name);

  const res = await gatewaySectorWorkFlows.get<PaginatedResponse<ObjectItem>>(
    `/objects?${queryParams.toString()}`,
    { headers: { Authorization: token } }
  );

  return res.data;
};
